export default "__VITE_ASSET__DQpJCkZG__"